'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { Button } from '@src/components/Button/Button';
import { useSession } from '@src/hooks/useSession';
import { useLocale } from '@src/i18n/LocaleProvider';
interface LoginModalFormProps {
  onClose: () => void;
  isOpen: boolean;
  redirectUrl?: string;
}
export function LoginModalForm(t0) {
  const $ = _c(12);
  const {
    onClose,
    isOpen,
    redirectUrl
  } = t0;
  const {
    login
  } = useSession();
  const {
    t
  } = useLocale("login-form");
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      const handleEsc = e => {
        if (e.key === "Escape" && isOpen) {
          onClose();
        }
      };
      document.addEventListener("keydown", handleEsc);
      return () => document.removeEventListener("keydown", handleEsc);
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== login || $[5] !== redirectUrl) {
    t3 = () => login({
      redirectUrl
    });
    $[4] = login;
    $[5] = redirectUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("cta");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="w-full"><Button type="submit" size="large" variant="primary" className="mt-5 mb-4 w-full" onClick={t3}>{t4}</Button></div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}